export default __webpack_public_path__ + "static/media/x86re.a7abc044.txt";